import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type IdColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const idColumnConfig = <T extends TableRow>({
  options,
}: IdColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'id',
  label: <Trans i18nKey="id" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">{value}</div>
  ),
  acessorKey: 'id',
  sortable: true,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
